
export default {
  name: "ClaimFillingActivitySection",
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    isClaimsFailedActivity: {
      type: Boolean,
      default: false
    },
    claimsData: {
      type: Object,
      default: () => ({})
    },
    updates: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    formatClaimsData(this: any): string {
      let html = "";

      if (this.isClaimsFailedActivity) {
        for (const update of this.updates) {
          html += `<p>${update?.field}: ${update?.update}</p>`;
        }
      } else {
        const data = this.claimsData;
        for (const key in data) {
          if (data[key]) {
            html += `<p>${key}: ${data[key]}</p>`;
          }
        }
      }
      return html;
    }
  }
};
